/* CreateInstanceDialogComponent.js */

"use strict";
const _ = require("lodash");
const glueJay = require("@gluenetworks/gluejay").Gluejay;
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CreateInstanceDialogRenderer"); //jshint ignore:line

class CreateInstanceDialogComponent extends EventEmitter {
    constructor(refResolver, nibApiService, userSession, opts) {
        super();
        //required
        this._refResolver = refResolver;
        this._nibApiService = nibApiService;
        this._userSession = userSession;
        this._renderer = new Renderer(this);

        //View Options
        this._title = _.get(opts, "title", "Provide Details");
        this._confirmationationDetails = _.defaults({}, _.get(opts, "confirmDetails"), {
            type: "text",
            text: "Create",
        });
        this._rejectionDetails = _.defaults({}, _.get(opts, "rejectDetails"), {
            type: "text",
            text: "Cancel",
        });

        //Other Options
        this._refLaunchedDetails = _.get(opts, "refLaunchedDetails");
        this._typePaths = this._getTypePathsFromRefLaunchedDetails(this._refLaunchedDetails);
        this._selectedType = _.get(opts, "selectedType");
        this._instanceData = _.get(opts, "instanceData");

        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _getTypePathsFromRefLaunchedDetails(launchDeets) {
        let typePaths = [];
        let paths = _.get(launchDeets, "configSettings.Ref.paths");

        if (!paths) {
            let path = _.get(launchDeets, "configSettings.Ref.path");
            if (path) {
                paths = [path];
            }
        }
        if (!_.isEmpty(paths)) {
            typePaths = [];
            paths.forEach((path) => {
                let explodedPath = glueJay.parsePath(path);
                let typePath = `/org/type/construct/${explodedPath.construct}`;
                if (explodedPath.ignored) {
                    typePath += "/" + explodedPath.ignored;
                }
                typePath += `/${explodedPath.typeName}.jtype`;
                typePaths.push(typePath);
            });
        }
        return typePaths;
    }
    _getSysPathFromOrgPath(path) {
        return path.replace(/org\//, "sys/");
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    set "$teve.ui.context"(cntxt) {
        //jshint ignore:line
        this._userFeedbackContext = cntxt;
    }
    get title() {
        return this.getTitle();
    }
    getTitle() {
        return this._title;
    }
    get confirmationDeets() {
        return this.getConfirmationDeets();
    }
    getConfirmationDeets() {
        return this._confirmationationDetails;
    }
    get rejectionDeets() {
        return this.getRejectionDeets();
    }
    getRejectionDeets() {
        return this._rejectionDetails;
    }
    get instanceData() {
        return this.getInstanceData();
    }
    getInstanceData() {
        return this._instanceData;
    }
    get selectedType() {
        return this.getSelectedType();
    }
    getSelectedType() {
        return this._selectedType;
    }
    set selectedType(st) {
        return this.setSelectedType(st);
    }
    setSelectedType(st, silent) {
        let old = this._selectedType;
        this._selectedType = st;
        if (!silent) {
            this.emit("SelectedTypeChanged", this._selectedType, old);
        }
        return this;
    }
    get typePaths() {
        return this.getTypePaths();
    }
    getTypePaths() {
        return this._typePaths;
    }
    get refResolver() {
        return this.getRefResolver();
    }
    getRefResolver() {
        return this._refResolver;
    }
    get userSession() {
        return this.getUserSession();
    }
    getUserSession() {
        return this._userSession;
    }
    get nibApiService() {
        return this.getNibApiService();
    }
    getNibApiService() {
        return this._nibApiService;
    }
    retrieveType(path) {
        return Promise.resolve().then(() => {
            return this._nibApiService.loadRefUnresolved({
                ref: path,
                orgId: this._userSession.activeOrganization.id,
            });
        });
    }
    saveInstance(path, instanceData) {
        return this._nibApiService.storageSaveData({
            ref: path,
            "@": "@",
            value: instanceData,
            orgId: this._userSession.activeOrganization.id,
        });
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START PUBLIC ACTION METHODS */
    /*******************************************/
    confirm(value) {
        this._userFeedbackContext.resolve(value);
    }
    reject(e) {
        this._userFeedbackContext.reject(e);
    }
    /*******************************************/
    /* END PUBLIC ACTION METHODS */
    /*******************************************/
}
module.exports = CreateInstanceDialogComponent;
